import React, { Component , Fragment } from "react";
import { Parallax } from "react-parallax";
import {Link} from "react-router-dom";
import Slider from "react-slick";
import { slickDot } from "../page-demo/script";

import Header from "../component/header/Header";

// Import google analytics 

import ReactGA from "react-ga4"



import Testimonial from "../elements/Testimonial";
import Team from "../elements/Team";
import FooterTwo from "../component/footer/FooterTwo";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Helmet from "../component/common/Helmet";

const image1 =
  "/assets/images/bg/paralax/bg-image-3-overlay.jpg";

  const SlideList = [
    {
        textPosition: 'text-center',
        category: '',
        title: 'Infinix Solutions ',
        description: 'The right solutions, at the right time',
        buttonText: 'Book a Discovery Call',
        buttonLink: '/contact'
    }
]

const portfolio_list = [
    {
        image: 'image-1',
        category: 'Data Engineering',
        title: 'SS&E Data Integration Pipeline',
        result: 'Built end-to-end Jenzabar -> SQL -> Python -> Canvas/Watermark pipeline enabling automated student success analytics',
        slug: 'ss-e-data-pipeline'
    },
    {
        image: 'image-2',
        category: 'Systems Integration',
        title: 'Canvas Enrollment & Term Sync Engine',
        result: 'Automated course/term overrides via Canvas API resolving data mismatches and improving evaluation accuracy',
        slug: 'canvas-enrollment-sync'
    },
    {
        image: 'image-3',
        category: 'AI / Automation',
        title: 'AI Content Automation System (n8n)',
        result: 'Designed pipeline generating, reviewing, and publishing social content using OpenAI, Baserow, and Meta APIs',
        slug: 'ai-content-automation'
    },
    {
        image: 'image-4',
        category: 'E-commerce / Growth',
        title: 'Shopify -> Meta Ads Optimization Engine',
        result: 'Built data-driven ad system with product feeds, event tracking, and creative automation to scale catalog performance',
        slug: 'shopify-meta-ads-engine'
    },
    {
        image: 'image-5',
        category: 'Data Engineering',
        title: 'MongoDB Product Normalization Layer',
        result: 'Created centralized product data model powering AI workflows, reporting, and multi-channel distribution',
        slug: 'mongodb-product-normalization'
    },
    {
        image: 'image-6',
        category: 'Automation / UX',
        title: 'Telegram Approval Workflow System',
        result: 'Implemented human-in-the-loop content approval system with dynamic state updates for AI-generated media',
        slug: 'telegram-approval-workflow'
    },
    {
        image: 'image-7',
        category: 'Data Engineering',
        title: 'SQL-Based Student Financial Aggregation',
        result: 'Engineered financial aggregation logic (balanceDue, transactions) for SS&E feeds ensuring data completeness and accuracy',
        slug: 'student-financial-aggregation'
    },
    {
        image: 'image-8',
        category: 'AI / Media',
        title: 'Multi-Platform AI Media Pipeline',
        result: 'Integrated Runway, Photoroom, ElevenLabs, and FFmpeg to automate creation of short-form video content at scale',
        slug: 'ai-media-pipeline'
    },
    // {
    //     image: 'image-3',
    //     category: 'Development',
    //     title: 'Getting tickets to the big show'
    // },
    // {
    //     image: 'image-4',
    //     category: 'Development',
    //     title: 'Getting tickets to the big show'
    // }
]




class InfinixHome extends Component{

   
    render(){
        
        ReactGA.send({
            hitType:"pageview",
            page:"/",
            title: "Home"
        });

        return(
            <Fragment>
                <Helmet pageTitle="Infinix Solutions" />
                <Header logo="light" />
                {/* Start Slider Area   */}
                <div className="slider-activation slider-creative-agency">
                    <Parallax bgImage={image1} strength={1000}>
                        {SlideList.map((value , index) => (
                            <div className="slide slide-style-2 slider-paralax d-flex align-items-center justify-content-center" key={index}>
                                <div className="container">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className={`inner ${value.textPosition}`}>
                                                {value.category ? <span>{value.category}</span> : ''}
                                                {value.title ? <h1 className="title theme-gradient">{value.title}</h1> : ''}
                                                {value.description ? <p className="description">{value.description}</p> : ''}
                                                {value.buttonText ? <div className="slide-btn"><a className="rn-button-style--2 btn-primary-color" href={`${value.buttonLink}`}>{value.buttonText}</a></div> : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Parallax>
                </div>
                {/* End Slider Area   */}


 

                {/* Start Portfolio Area */}
                <div className="portfolio-area pt--120 pb--140 bg_color--5">
                    <div className="rn-slick-dot">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="section-title service-style--3 text-left mb--15 mb_sm--0">
                                        <h2 className="title">Our highlights</h2>
                                        <p>Dive into our favorite projects  - a showcase of our IT excellence.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slick-space-gutter--15 slickdot--20">
                                        <Slider {...slickDot}>
                                            {portfolio_list.map((value , index) => (
                                                <div className="portfolio" key={index}>
                                                    <div className="thumbnail-inner">
                                                        <div className={`thumbnail ${value.image}`}></div>
                                                        <div className={`bg-blr-image ${value.image}`}></div>
                                                    </div>
                                                    <div className="content">
                                                        <div className="inner">
                                                            <p>{value.category}</p>
                                                            <h4><a href={`/case-study/${value.slug}`}>{value.title}</a></h4>
                                                            <p>{value.result}</p>
                                                            <div className="portfolio-button">
                                                                <a className="rn-btn" href={`/case-study/${value.slug}`}>Case Study</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <Link className="link-overlay" to={`/case-study/${value.slug}`}></Link>
                                                </div>
                                            ))}
                                        </Slider>
                                    </div>
                                </div>

                                    {/* <div className="col">
                                        <a className="rn-btn" href="">
                                            <span>Our Portfolio</span>
                                        </a>
                                    </div> */}

                               
                            </div>

                        </div>
                    </div>
                </div>
                {/* End Portfolio Area */}


                {/* Start CounterUp Area */}
                {/* <div className="rn-counterup-area pt--140 p pb--110 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <h3 className="fontWeight500">Our Fun Facts</h3>
                                </div>
                            </div>
                        </div>
                        <CounterOne />
                    </div>
                </div> */}
                {/* End CounterUp Area */}

                {/* Start Team Area  */}
                <div className="rn-team-area ptb--120 bg_color--5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="section-title service-style--3 text-left mb--25 mb_sm--0">
                                    <h2 className="title">Ambitious Entrepreneurs </h2>
                                    <p>Meet Us</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <Team column="col-lg-4 col-md-6 col-sm-6 col-12" />
                        </div>
                    </div>
                </div>
                {/* End Team Area  */}

                {/* Start Testimonial Area */}
                <div className="rn-testimonial-area bg_color--1 ptb--120">
                    <div className="container">
                        <Testimonial />
                    </div>
                </div>
                {/* End Testimonial Area */}
                

                {/* Start Blog Area */}
                {/* <div className="rn-blog-area pt--120 pb--140 bg_color--5">
                    <div className="container">
                        <div className="row align-items-end">
                            <div className="col-lg-6">
                                <div className="section-title text-left">
                                    <h2>Latest News</h2>
                                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row mt--55 mt_sm--30 rn-slick-dot slick-space-gutter--15 slickdot--20 row--0">
                            <div className="col-lg-12">
                                <Slider {...slickDot}>
                                    {PostList.map((value , i ) => (
                                        <div className="blog blog-style--1" key={i}>
                                            <div className="thumbnail">
                                                <a href="/blog-details">
                                                    <img src={`/assets/images/blog/blog-${value.images}.jpg`} alt="Blog Images"/>
                                                </a>
                                            </div>
                                            <div className="content">
                                                <p className="blogtype">{value.category}</p>
                                                <h4 className="title"><a href="/blog-details">{value.title}</a></h4>
                                                <div className="blog-btn">
                                                    <a className="rn-btn text-white" href="/blog-details">Read More</a>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>    
                    </div>    
                </div> */}
                {/* End Blog Area */}


                {/* Start Brand Area */}
                {/* <div className="rn-brand-area brand-separation bg_color--5 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <BrandTwo />
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* End Brand Area */}

                 {/* Start Footer Style  */}
                 <FooterTwo />
                {/* End Footer Style  */}
                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

            </Fragment>
        )
    }
}

export default InfinixHome;